import React from "react";
import {Route, Routes} from 'react-router-dom';
import LoadingPage from "./pages/LoadingPage";
import {useSelector} from "react-redux";
import CheckPage from "./pages/CheckPage";

const App = () => {

    const size = useSelector(state => state.screenSize);

    return (
        <Routes>
            <Route path="/loading" element={<LoadingPage/>}/>
            <Route path="/" element={<CheckPage/>}/>
        </Routes>
    );
}

export default App;
